import request from '@/utils/request';

// 验证
export function authUser(params) {
  return request({
    url: `/client-user/verify`,
    method: 'post',
    params
  });
}

// 修改手机号
export function changePhone(params) {
  return request({
    url: `/client-user/modifyPhone`,
    method: 'post',
    params
  });
}

// 扫码获取组织
export function getCurrentOrg(id) {
  return request({
    url: `/organization/${id}`,
    method: 'get'
  });
}
